<span uppVisible (visibilityChange)="onVisibilityChange($event)">
    <div style="display: contents;">
        <ng-content></ng-content>
    </div>
</span>